module.exports = __webpack_public_path__ + "media/images/design/common/images/menu06-808a2253432821f2e8e9ce4da6c1a719.png";